import React, {useEffect} from "react";
import styles from "../assets/css/gallerySlideShow.module.scss";

const GallerySlideShow = (props) => {


// Next/previous controls
    function plusSlides(n) {
        showSlides(window.slideIndex += n);
    }

// Thumbnail image controls
    function currentSlide(n) {
        showSlides(window.slideIndex = n);
    }

    function showSlides(n) {
        let i;
        let slides = document.getElementsByClassName(styles.mySlides);
        let dots = document.getElementsByClassName(styles.demo);


        if (n > slides.length) {
            window.slideIndex = 1
        }
        if (n < 1) {
            window.slideIndex = slides.length
        }
        for (i = 0; i < slides.length; i++) {
            if (slides[i] && slides[i] !== undefined)
                slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
            if (dots[i] && dots[i] !== undefined)
                dots[i].className = dots[i].className.replace(` ${styles.active}`, "");
        }
        if (slides[window.slideIndex - 1] && slides[window.slideIndex - 1] !== undefined)
            slides[window.slideIndex - 1].style.display = "block";
        if (dots[window.slideIndex - 1] && dots[window.slideIndex - 1] !== undefined)
            dots[window.slideIndex - 1].className += ` ${styles.active}`;
    }

    window.slideIndex = 1;
    useEffect(() => {
        showSlides(window.slideIndex);

    }, []);

    return <div className={styles.container}>


        {props.list.map((item, index) => <div className={styles.mySlides} key={index}>
                <div className={styles.numbertext}>{index + 1} / {props.list.length}</div>
                <img src={item.img} alt={""}/>
            </div>
        )}


        <a className={styles.prev} onClick={e => {
            plusSlides(-1)
        }}>&#10094;</a>
        <a className={styles.next} onClick={e => {
            plusSlides(1)
        }}>&#10095;</a>

        <div style={{width:"100%",overflowX:"scroll",height:125}}>

            <div className={styles.row}>

                {props.list.map((item, index) => <div className={styles.column} key={index}>
                        <img className={`${styles.demo} ${styles.cursor}`} src={item.img}
                             onClick={e => {
                                 currentSlide(index + 1)
                             }}
                             alt="The Woods"/>
                    </div>
                )}

            </div>
        </div>



    </div>;


};

export default GallerySlideShow;